import React, { Component } from "react";
import './MiniAudioPlayer.css';

export default class MiniAudioPlayer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			playing: false
		};

		this.audioRef = element => {
			this.audioElement = element;
		};
	}

	componentDidUpdate(prevProps) {
		// Jeśli rodzic zmienił stan isPlaying na false dla tego odtwarzacza, a lokalnie jeszcze grał
		if (prevProps.isPlaying && !this.props.isPlaying && this.state.playing) {
			this.setState({ playing: false });
			if (this.audioElement) {
				this.audioElement.pause();
			}
		}
	}

	togglePlay = () => {
		if (this.state.playing) {
			this.setState({ playing: false });
			this.audioElement.pause();
		} else {
			// Zabezpieczenie: sprawdzamy czy funkcja została przekazana przez rodzica
			if (this.props.onPlayStateChange) {
				this.props.onPlayStateChange();
			}
			this.setState({ playing: true });
			this.audioElement.play();
		}
	}

	render() {
		const playIcon = `<svg version="1.1" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        width="26px" height="26px" viewBox="0 0 26 26" enable-background="new 0 0 26 26" xml:space="preserve">
        <path fill="black" d="M13,0.696c6.784,0,12.304,5.52,12.304,12.303c0,6.785-5.521,12.304-12.304,12.304
        c-6.784,0-12.303-5.52-12.303-12.304C0.696,6.216,6.215,0.696,13,0.696 M13,0C5.819,0,0,5.82,0,13c0,7.179,5.819,13,13,13
        c7.178,0,13-5.821,13-13C26,5.82,20.178,0,13,0L13,0z"/>
        <path fill="black" d="M17.539,12.83l-6.164-4.017c-0.034-0.022-0.072-0.033-0.111-0.033c-0.033,0-0.066,0.008-0.096,0.024
        c-0.066,0.035-0.107,0.104-0.107,0.178L11.061,13l0.001,4.017c0,0.074,0.041,0.144,0.107,0.179c0.029,0.017,0.063,0.024,0.096,0.024
        c0.039,0,0.077-0.011,0.111-0.033l6.164-4.017c0.059-0.038,0.093-0.102,0.093-0.17S17.598,12.868,17.539,12.83z"/>
        </svg>`;

		const muteIcon = `<svg version="1.1" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        width="26px" height="26px" viewBox="0 0 26 26" enable-background="new 0 0 26 26" xml:space="preserve">
        <path fill="black" d="M13,0.696c6.784,0,12.304,5.52,12.304,12.303c0,6.785-5.52,12.304-12.304,12.304S0.696,19.784,0.696,13
       C0.696,6.216,6.216,0.696,13,0.696 M13,0C5.82,0,0,5.82,0,13c0,7.179,5.82,13,13,13s13-5.821,13-13C26,5.82,20.18,0,13,0L13,0z"/>
        <path fill="black" d="M19.521,10.359c0,0-3.384-3.356-3.633-3.625c-0.247-0.269-0.375-0.377-0.375-0.592
       c0-0.01-0.005-0.02-0.006-0.029V5.663c0-0.214-0.174-0.387-0.388-0.387c-0.213,0-0.388,0.173-0.388,0.387v2.002
       c0,0.01,0.006,0.019,0.007,0.029v7.542c-0.584-0.585-1.528-0.969-2.603-0.969-1.774,0-3.215,1.041-3.215,2.326
       c0,1.284,1.44,2.324,3.215,2.324c1.661,0,3.377-1.326,3.377-2.41V7.449l3.459,3.458c0.076,0.076,0.177,0.113,0.275,0.113
       s0.198-0.038,0.273-0.113C19.673,10.756,19.672,10.511,19.521,10.359z"/>
        </svg>`;

		return (
			<div className="MiniAudioPlayer">
				<div 
					className="audio__wrapper--icon play-icon" 
					onClick={this.togglePlay} 
					style={{ cursor: "pointer" }}
					dangerouslySetInnerHTML={{ __html: playIcon }}
				></div>
				<div 
					className="audio__wrapper--icon" 
					dangerouslySetInnerHTML={{ __html: muteIcon }}
				></div>
				<audio ref={this.audioRef} src={this.props.src}></audio>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Components/Elements/MiniAudioPlayer/index.jsx